var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtmlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 70,
    viewBox: "0 0 63 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.199219 0L4.54688 61.2639L31.125 70L57.7029 61.2639L62.0505 0H0.199219Z",
    fill: "#FF7816"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0506 0L57.703 61.2639L31.125 70V0H62.0506Z",
    fill: "#FF4B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4414 18.5938H20.0488L20.7868 28.8477H49.7034L47.9393 53.6755L31.1229 59.2948L14.3065 53.6755L13.7324 45.3906H21.9355L22.0996 47.6465L31.123 50.6404L40.1465 47.6465L40.8845 37.0508H13.1172L11.2305 10.3906H51.0156L50.4414 18.5938Z",
    fill: "#ECECF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7055 28.8477L47.9414 53.6755L31.125 59.2948V50.6405L40.1484 47.6465L40.8866 37.0508H31.125V28.8477H49.7055ZM51.0177 10.3906L50.4435 18.5938H31.1251V10.3906H51.0177Z",
    fill: "#E2E2E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlIcon);
export default __webpack_public_path__ + "static/media/html_icon.3d4605aa262f255a5d80cce620533232.svg";
export { ForwardRef as ReactComponent };